export default {
  readon: '繼續閱讀',
  learnmore: '了解更多',
  submit: '遞交',
  filter: '篩選搜尋結果',
  cancel: '取消',
  apply: '套用',
  compver: '比較不同版本',
  show: '顯示',
  back: '返回',
  prev_page: '上一頁',
  all: '所有',
  close: '關閉',
  goto: '前往',
  howto: '如何',
  print: '列印此文件',
  advagain: '再次進階搜尋',
  use: '進行',
  togglehl: '開關搜尋字標記',
  next: '下一項',
  prev: '上一項',
  collapse: '收起',
  showall: '顯示全部',
  checkcontent: '一頁顯示所有內容',
  showless: '收起部分',
  shortcut: '快速連結',
  search: "搜尋",
  contactus: '聯絡我們',
  donate: '捐款',
  feedback: '遞交意見',
  selectall: "全選",
  deselect: "全部取消",
  reset_form: "重設表格",
  case_showalltitle: '顯示全部名稱',
  case_collapsetitle: '收起部分名稱',
  ft_support: '支持 HKLII',
  ft_legal: '政策及條款',
  ft_link: '連結',
  ft_disclaimer: '免責聲明',
  ft_donors: '捐款人',
  ft_home: '主頁',
  hd_liis: '其他 LII',
  classic: '經典',
  news: '新功能簡介',
  newfeature: '新功能',
}